import { ROLE_ROOT, ROLE_PARTNER } from '../../constants/roles'

export const canListCompanies = ({ role }) =>
   [ROLE_ROOT, ROLE_PARTNER].includes(role)
